import { render, staticRenderFns } from "./5-bg.vue?vue&type=template&id=bab75426&"
import script from "./5-bg.vue?vue&type=script&lang=js&"
export * from "./5-bg.vue?vue&type=script&lang=js&"
import style0 from "./5-bg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports